import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
const names = ['Martín G.', 'Sofía P.', 'Lucas R.', 'Camila B.', 'Joaquín D.', 'Agustina M.', 'Federico L.', 'Valentina S.', 'Mateo F.', 'Julieta C.', 'Nicolás H.', 'Florencia A.', 'Tomás V.', 'Micaela O.', 'Bruno T.', 'Antonella E.', 'Franco I.', 'Catalina N.', 'Ezequiel Q.', 'Romina U.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Resistencia', 'San Juan', 'Bahía Blanca', 'Posadas', 'Paraná', 'Río Cuarto', 'Comodoro Rivadavia', 'San Luis'];
const offers = ['Sistema Anti-Ansiedad — PDF Digital', 'Sistema Anti-Ansiedad + 6 Bonos Estratégicos'];
const timeAgo = ['hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos', 'hace 8 minutos', 'hace 11 minutos', 'hace 14 minutos', 'hace 17 minutos'];
interface Purchase {
  id: number;
  name: string;
  city: string;
  offer: string;
  time: string;
}
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generatePurchase(id: number): Purchase {
  return {
    id,
    name: pick(names),
    city: pick(cities),
    offer: pick(offers),
    time: pick(timeAgo)
  };
}
export function PurchaseNotification() {
  const [current, setCurrent] = useState<Purchase | null>(null);
  useEffect(() => {
    let counter = 0;
    let dismissTimer: ReturnType<typeof setTimeout> | null = null;
    let nextTimer: ReturnType<typeof setTimeout> | null = null;
    const showNext = () => {
      counter += 1;
      setCurrent(generatePurchase(counter));
      // Hide after ~6 seconds
      dismissTimer = setTimeout(() => {
        setCurrent(null);
        // Schedule next between 40 and 60 seconds later
        const delay = 40000 + Math.random() * 20000;
        nextTimer = setTimeout(showNext, delay);
      }, 6000);
    };
    // First popup appears after ~8 seconds
    const initial = setTimeout(showNext, 8000);
    return () => {
      clearTimeout(initial);
      if (dismissTimer) clearTimeout(dismissTimer);
      if (nextTimer) clearTimeout(nextTimer);
    };
  }, []);
  return <div aria-live="polite" aria-atomic="true" className="fixed bottom-4 left-4 z-50 pointer-events-none max-w-[calc(100vw-2rem)] sm:max-w-sm" data-id="element-159">
      <AnimatePresence mode="wait" data-id="element-160">
        {current && <motion.div key={current.id} initial={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.5,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="pointer-events-auto bg-charcoal border border-white/15 shadow-2xl shadow-black/40 backdrop-blur-sm rounded-sm overflow-hidden" data-id="element-161">
            <div className="flex items-start gap-3 p-4" data-id="element-162">
              <div className="shrink-0 w-10 h-10 rounded-full bg-terracotta/15 border border-terracotta/30 flex items-center justify-center" data-id="element-163">
                <ShieldCheck size={18} className="text-terracotta" data-id="element-164" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-165">
                <div className="flex items-center gap-2 mb-1" data-id="element-166">
                  <span className="text-[10px] uppercase tracking-widest text-terracotta font-semibold" data-id="element-167">
                    ✓ Compra verificada
                  </span>
                </div>
                <p className="text-sm text-cream leading-snug" data-id="element-168">
                  <span className="font-medium" data-id="element-169">{current.name}</span>
                  <span className="text-cream/60" data-id="element-170"> de </span>
                  <span className="font-medium" data-id="element-171">{current.city}</span>
                </p>
                <p className="text-xs text-cream/60 mt-0.5 leading-snug truncate" data-id="element-172">
                  {current.offer}
                </p>
                <p className="text-[10px] text-cream/40 mt-1.5" data-id="element-173">
                  {current.time}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}